import axios from 'axios'
import safeJSONParse from '../../../scripts/utils/safeJsonParse'
import shapeSettings from './shapeSettings'
import { IRCProductSettings, ISubBuilderSettings } from './types'
import { Product, ProductVariant } from '../../util/typings'

export const camelCase = (str: string): string => str.replace(/_([a-z])/g, (_x, up) => up.toUpperCase())


export const camelCaseKeys = (obj: Record<string, any>) : Record<string, any> => {
  return Object.entries(obj).reduce((acca, [key, value]) => {
    const camelCaseKey = camelCase(key)
    return {
      ...acca,
      [camelCaseKey]: value
      
    }
  }, {} as Record<string, any>)
}

export const getSettings = (): ISubBuilderSettings => {
  const settingIds = [
    'subProductSettings',
    'subGrindSettings',
    'subRoutineSettings',
    'subDurationSettings',
    'subQuantitySettings',
    'subDateSelectorSettings',
    'subCalculatorSettings',
    'subSummarySettings'
  ]
  const rawSettings = settingIds.reduce((acca, id) => {
    const scriptEl = document.getElementById(id) as HTMLScriptElement
    const data = safeJSONParse(scriptEl.innerText, {}) as Record<string, any>
    return {
      ...acca,
      [id]: data
    }
  }, {} as Record<string, any>)

  const settings  = shapeSettings(rawSettings)
  return settings
}


// Dates are compared by calendar day, not by identity or timestamp: excluded
// dates are parsed to midnight, while the dates we test against are often
// derived from `new Date()` and so carry a time of day.
export const isExcludedDate = (date: Date, excludedDates: Date[] = []): boolean => {
  for (let i = 0; i < excludedDates.length; i++) {
    const excluded = excludedDates[i]
    if (
      excluded.getFullYear() === date.getFullYear() &&
      excluded.getMonth() === date.getMonth() &&
      excluded.getDate() === date.getDate()
    ) {
      return true
    }
  }
  return false
}

export const getXWorkingDaysInFuture = (x: number, excludedDates: Date[] = []): Date => {
  const ret = new Date()
  while (x > 0) {
    ret.setDate(ret.getDate() + 1)
    if (ret.getDay() === 0 || isExcludedDate(ret, excludedDates)) {
      continue;
    }
    x--;
  }
  return ret;
}

export const getXDaysInFuture = (x: number): Date => {
  const ret = new Date()
  ret.setDate(ret.getDate() + x)
  return ret;
}

export const getXWorkingDaysBeforeDate = (x: number, date: Date, excludedDates: Date[] = []): Date => {
  const ret = new Date(date.getTime()) // clone
  while (x > 0) {
    ret.setDate(ret.getDate() - 1)
    if (ret.getDay() === 0 || isExcludedDate(ret, excludedDates)) {
      continue;
    }
    x--;
  }
  return ret;
}

export const isKgVariant = (v: ProductVariant): boolean => {
  return /1\s*kg/i.test(v.option1 || '') ||
         /1\s*kg/i.test(v.option2 || '') ||
         /1\s*kg/i.test(v.option3 || '')
}

export const findKgVariantOnProduct = (product: Product, grindOption: string | null): ProductVariant | null => {
  if (!product?.variants) return null
  return product.variants.find(v => {
    if (!isKgVariant(v)) return false
    if (!grindOption) return true
    return v.option1 === grindOption || v.option2 === grindOption || v.option3 === grindOption
  }) || null
}

export const aysncGetRCProductOptions = async (handle: string): Promise<IRCProductSettings> => {
  try {
    const { data } = await axios.get(`/products/${handle}?view=recharge_data`)
    const freqs = (data.shippingIntervalFrequency as string).split(',').map((str: string) => {
      const amount = parseInt(str)
      return amount
    })
    return {
      amounts: freqs,
      unit: data.shippingIntervalType
    }
  } catch (e) {
    console.info(e)
    console.info('Check product exists in recharge')
    return {
      amounts: [],
      unit: null
    }
  }
  
}
